import React from 'react';

export const processMetatags = (
    metatags: {
        tag: string;
        attributes: {
            content: string;
            property: string;
            href: string;
            name: string;
            rel: string;
        };
    }[]
) => {
    const outTags: JSX.Element[] = [];
    if (!metatags) return [];

    const canonicalTag = metatags.find(
        (metatag) => metatag.attributes.rel === `canonical`
    );

    if (!canonicalTag) {
        outTags.push(
            React.createElement(`link`, {
                rel: `canonical`,
                key: `canon`,
                href: typeof window !== `undefined` ? window.location.href : ``,
            })
        );
    } else {
        const url = new URL(canonicalTag.attributes.href);
        url.protocol = `https:`;
        url.host = `www.spectrumreach.com`;
        canonicalTag.attributes.href = url.toString();
        outTags.push(
            React.createElement(canonicalTag.tag, {
                ...canonicalTag.attributes,
                key: `head-${JSON.stringify(canonicalTag)}`,
            })
        );
    }

    for (const metatag of metatags.filter(
        (metatag) =>
            metatag.tag !== `link` &&
            (metatag.attributes.name || metatag.attributes.property)
    )) {
        const elem = React.createElement(metatag.tag, {
            ...metatag.attributes,
            id: metatag.attributes.name
                ? metatag.attributes.name
                : metatag.attributes.property,
            key: `head-${JSON.stringify(metatag)}`,
        });
        outTags.push(elem);
    }

    if (!outTags.find((tag) => tag.type === `title`)) {
        const titleTag = metatags.find(
            (tag) => tag.attributes.name === `title`
        );
        if (titleTag) {
            const titleVal = titleTag.attributes.content;
            outTags.push(
                <title id="title" key="page-title">
                    {titleVal}
                </title>
            );
        }
    }

    return outTags;
};
